<template>
  <div>
    <p>
      {{ notificationData.userNames }} {{ $t(addedText) }}
      <component :is="($router ? 'router-link': 'a')" :href="'/develop/lesson/' + notificationData.lessonId + '/view'" :to="'/develop/lesson/' + notificationData.lessonId + '/view'">
        {{ notificationData.lessonName }}
      </component>
      {{ $t('in Unit') }}
      <router-link :to="`/develop/unit/${notificationData.id}/lessons`">
        <span v-html="notificationData.name"></span>
      </router-link>
    </p>
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'lessonNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    }
  },
  computed: {
    addedText () {
      const verb = this.notificationData.userNames.length > 1 ? 'were' : 'was'
      const label = this.notificationData.userNames.length > 1 ? 'collaborators' : 'a collaborator'
      return `${verb} added as ${label} on Lessons`
    }
  }
}
</script>
